import React from 'react';
import PropTypes from 'prop-types';

const MultimediaEmbeddedVideoItem = ({ mediaProperties }) => {
  const displayVideoEmbedHtml = () => {
    // This is needed to bypass React's restriction against programatically inserting HTML.
    // dangerouslySetInnerHTML is used below to call this function.
    return { __html: mediaProperties.videoEmbedHtml };
  };

  return (
    <>
      {/* eslint-disable-next-line react/no-danger */}
      <div className="multimedia-add-ons__wrapper__embed" dangerouslySetInnerHTML={displayVideoEmbedHtml()} />
      <div className="multimedia-add-ons__wrapper__caption">
        {mediaProperties.caption ?? mediaProperties.caption}
      </div>
    </>
  );
};

MultimediaEmbeddedVideoItem.propTypes = {
  mediaProperties: PropTypes.shape({
    publicId: PropTypes.string.isRequired,
    multimediaAddOnId: PropTypes.number.isRequired,
    fileName: PropTypes.string.isRequired,
    mediaType: PropTypes.string.isRequired,
    caption: PropTypes.string.isRequired,
    videoEmbedHtml: PropTypes.string.isRequired,
  }).isRequired,
};

export default MultimediaEmbeddedVideoItem;
